/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 固定资产模块接口</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2026年09月22日</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	//固定资产类别
	category: {
		list(params = {}) {
			return Ajax.get('/asset-category', params)
		},
		save(p) {
			return Ajax.post('/asset-category', p)
		},
		update(p) {
			return Ajax.put('/asset-category', p)
		},
		delete(id) {
			return Ajax.delete(`/asset-category/${id}`)
		}
	},
	//固定资产卡片
	card: {
		list(params = {}) {
			return Ajax.get('/asset-card', params)
		},
		save(p) {
			return Ajax.post('/asset-card', p)
		},
		update(p) {
			return Ajax.put('/asset-card', p)
		},
		delete(id) {
			return Ajax.delete(`/asset-card/${id}`)
		},
		//折旧计提
		depreciate(params) {
			return Ajax.post('/asset-card/depreciate', params)
		},
		//折旧计提预览
		preview(params) {
			return Ajax.post('/asset-card/preview', params)
		},
		//清理处置
		dispose(id) {
			return Ajax.post(`/asset-card/dispose/${id}`)
		}
	}
};
